import { render, staticRenderFns } from "./shutDown.vue?vue&type=template&id=645f0690"
import script from "./shutDown.vue?vue&type=script&lang=js"
export * from "./shutDown.vue?vue&type=script&lang=js"
import style0 from "./shutDown.vue?vue&type=style&index=0&id=645f0690&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports